<script>
  import Input from '@ui/pico/input.svelte';
  import { editForm, getForm } from '../../services';
  import { pages } from '../../config';
  import FeIcon from '../components/fe-icon.svelte';
  import { goto } from '../../util';
  import BuilderAccordion from '../components/accordion/builder-accordion.svelte';
  import FormPowerupAccordion from '../components/accordion/form-powerup-accordion.svelte';
  import FormSubmissionsAccordion from '../components/accordion/form-submissions-accordion.svelte';
  import { account } from '../../store';
  export let params;

  const fid = params.fid;
  const mode = 'form.overview';
  let open = false;
  let formSubmissionsOpen = true;
  let showEditSiteForm = false;
  let formName = '';
  let formLinkCode = '';
  let site;
  let form;
  let attempts = 1;
  let attemptLimit = 3;

  $: returnTo = `?from=${mode}`;

  $: {
    if (!form && $account) {
      init();
    }
  };

  async function init() {
    if ($account && !form) {
      form = await getForm({ fid: params.fid });
      site = form?.site;

      formName = form?.name;
      formLinkCode = form?.formLinkCode;
    }
    attempts = attempts+1;

    if (attempts >= attemptLimit) {
      consol.warn('Not found');
      // goto(pages.account.overview.url);
    }
  }

  function triggerEdit() {
    showEditSiteForm = true;
  }
  function hideEdit() {
    showEditSiteForm = false;
  }
  async function finishEdit() {
    const res = await editForm({
      fid: params.fid,
      name: formName,
      formLinkCode,
    });
    form = await getForm({ fid: params.fid });
    hideEdit();
  }
  function goToSiteOverview() {
    if (site._id) {
      goto(pages.sites.overview.url, site._id, returnTo);
    } else {
      goto(pages.account.url, returnTo);
    }
  }
</script>

<nav aria-label="breadcrumb">
  <ul>
    <li>
      <a href={pages.dashboard.url}>
        <i class="ri-home-3-line" />
      </a>
    </li>
    <li>
      <a on:click|preventDefault={goToSiteOverview} href={pages.dashboard.url}>
        {site?.domain || '...'}
      </a>
    </li>
    <li>
      {form?.name || '...'}
      <FeIcon name="edit" on:click={triggerEdit} />
    </li>
  </ul>
</nav>

<form on:submit|preventDefault={finishEdit}>
  <dialog open={showEditSiteForm}>
    <article>
      <h3>Edit Form</h3>
      <Input type="text" bind:value={formName} name="name" label="Name" />
      <Input
        type="text"
        bind:value={formLinkCode}
        name="formLinkCode"
        label="Form Link Code"
      />
      <footer>
        <button type="button" class="secondary" on:click={hideEdit}
          >Cancel</button
        >
        <button type="submit">Update</button>
      </footer>
    </article>
  </dialog>
</form>

<header class="page-title">
  <h1>Form Overview</h1>
</header>

{#if form}
  <BuilderAccordion title="Builder" {form} />
  <FormPowerupAccordion {fid} {form} {open} />
  <FormSubmissionsAccordion {fid} open={formSubmissionsOpen} />
{/if}

<style>
  nav {
    height: 0;
    margin-bottom: 3rem;
  }
  :global(td.cta > *) {
    vertical-align: middle;
  }
  dialog article {
    width: 600px;
  }
</style>
